import { useEffect } from "react"
import EventMasterForm from "./EventMasterForm"

const EventMaster = ({ open }) => {
    useEffect(() => {
        document.title = 'Event Master'
    }, [])
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <EventMasterForm />
        </main>
    )
}
export default EventMaster